import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// 緊急連絡先申請検索
export const i_0004_query = (userCd) => {
  return http.requestQuickGet(apiUrl.apiUrl_EmergencyContact + '?userId=' + userCd)
}
// 緊急連絡先申請更新
export const i_0004_update = (params, userCd) => {
  return http.requestPost(apiUrl.apiUrl_EmergencyContact + '?userCd=' + userCd, params);
}


// WEBPACK FOOTER //
// ./src/module/api/i_0004.js